(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iyyakee-mobile-comfort"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = matchMedia('(max-width: 749px)');
  let chat;
  let sticky;
  let frame;
  let observer;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      if (!chat) return;
      const rect = mobile.matches && sticky ? sticky.getBoundingClientRect() : null;
      const visible = rect && sticky.classList.contains('is-visible') && rect.bottom > 0 && rect.top < innerHeight;
      const bottom = mobile.matches ? `${visible ? Math.max(16, innerHeight - rect.top + 12) : 16}px` : '';
      if (chat.style.bottom !== bottom) {
        if (bottom) chat.style.setProperty('bottom', bottom, 'important');
        else chat.style.removeProperty('bottom');
      }
      if (mobile.matches) {
        chat.style.setProperty('left', 'auto', 'important');
        chat.style.setProperty('right', '12px', 'important');
      } else {
        chat.style.removeProperty('left');
        chat.style.removeProperty('right');
      }
    });
  };
  const discover = () => {
    chat = document.querySelector('#ShopifyChat, #shopify-chat, shopify-chat, .shopify-chat');
    sticky = document.querySelector('.iyyakee-mobile-buybar, .iyyakee-sticky-cart');
    if (!chat) return;
    observer?.disconnect();
    if (sticky) {
      new MutationObserver(schedule).observe(sticky, { attributes:true, attributeFilter:['class','style'] });
      new ResizeObserver(schedule).observe(sticky);
    }
    schedule();
  };
  observer = new MutationObserver(discover);
  observer.observe(document.body, {childList:true,subtree:true});
  discover();
  setTimeout(() => observer.disconnect(), 15000);
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iyyakee-order-note-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('iyyakee-order-note')) return;
  const fields = new Set();
  let desired;
  let saved;
  let endpoint;
  let pending = null;
  let timer;
  let state = '';
  const resuming = new WeakSet();
  const submitting = new WeakSet();

  function paint() {
    for (const field of fields) {
      const input = field.querySelector('textarea');
      if (input.value !== desired) input.value = desired;
      field.dataset.state = state;
      field.querySelector('[data-note-status]').textContent = field.dataset[state] || '';
      field.querySelector('[data-note-retry]').hidden = state !== 'error';
      input.setAttribute('aria-invalid', state === 'error' ? 'true' : 'false');
    }
  }

  function setNote(value) {
    desired = value;
    state = desired === saved && !pending ? 'saved' : 'saving';
    paint();
    clearTimeout(timer);
    timer = setTimeout(() => flush().catch(() => {}), 450);
  }

  async function flush() {
    clearTimeout(timer);
    if (pending) {
      await pending;
      return flush();
    }
    if (desired === undefined || desired === saved) return;
    state = 'saving';
    paint();
    pending = (async () => {
      while (desired !== saved) {
        const value = desired;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          keepalive: true,
          body: JSON.stringify({ note: value }),
        });
        if (!response.ok) throw new Error('Note save failed');
        const cart = await response.json();
        if (String(cart.note ?? '') !== value) throw new Error('Note not confirmed');
        saved = value;
      }
      state = 'saved';
    })();
    try {
      await pending;
    } catch (error) {
      state = 'error';
      throw error;
    } finally {
      pending = null;
      paint();
    }
  }

  class OrderNote extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('textarea');
      if (!input || fields.has(this)) return;
      if (desired === undefined) {
        const edited = [...document.querySelectorAll('iyyakee-order-note textarea')]
          .find(area => area.value !== area.defaultValue);
        desired = edited ? edited.value : input.value;
        saved = input.defaultValue;
        if (desired !== saved) {
          state = 'saving';
          timer = setTimeout(() => flush().catch(() => {}), 450);
        }
      }
      endpoint = this.dataset.updateUrl;
      fields.add(this);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      input.addEventListener('input', () => setNote(input.value), options);
      input.addEventListener('change', () => flush().catch(() => {}), options);
      this.querySelector('[data-note-retry]').addEventListener('click', () => flush().catch(() => {}), options);
      paint();
    }
    disconnectedCallback() {
      fields.delete(this);
      this.abort?.abort();
    }
  }

  customElements.define('iyyakee-order-note', OrderNote);
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('#cart-form, [data-cart-form]')) return;
    if (resuming.has(form)) {
      resuming.delete(form);
      return;
    }
    if (desired === undefined || (!pending && desired === saved)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting.has(form)) return;
    submitting.add(form);
    const button = event.submitter;
    button?.setAttribute('aria-busy', 'true');
    try {
      await flush();
      if (!form.isConnected) return;
      resuming.add(form);
      form.requestSubmit(button?.isConnected && button.form === form ? button : undefined);
    } catch {
      const field = [...fields].find(item => item.getClientRects().length);
      const disclosure = field?.closest('details');
      if (disclosure) disclosure.open = true;
      field?.querySelector('textarea').focus();
    } finally {
      submitting.delete(form);
      button?.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) flush().catch(() => {});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
